// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.tag-slider-wrapper {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none; /* Firefox */
}

/* Ẩn scrollbar trên Chrome/Safari */
.tag-slider-wrapper::-webkit-scrollbar {
  display: none;
}

/* Hover: hiện scrollbar */
.tag-slider-wrapper:hover {
  scrollbar-width: thin; /* Firefox */
}

/* Hover: hiện scrollbar trên Chrome/Safari */
.tag-slider-wrapper:hover::-webkit-scrollbar {
  display: block;
  height: 6px;
}

.tag-slider-wrapper:hover::-webkit-scrollbar-thumb {
  background: #999;
  border-radius: 3px;
}

.tag-slider-track {
  display: flex;
  flex-wrap: nowrap;
  width: max-content;
  margin-bottom: 10px;
}

.tag-item {
  background-color: #f1f4ff;
  border-radius: 12px;
  cursor: pointer;
  font-size: 16px;
  color: #198754;
  transition: background-color 0.2s;
  margin-right: 12px;
  display: inline-flex;
  align-items: center;
  padding: 8px 12px;
  white-space: nowrap;
  flex: 0 0 auto;
  border: none;
}

.tag-item:hover {
  background-color: #e0eaff;
}

.tag-icon {
  width: 25px;
  height: 25px;
  margin-right: 8px;
  object-fit: contain;
}`, "",{"version":3,"sources":["webpack://./src/components/shared/post/TagSlider.css"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,iCAAA;EACA,qBAAA,EAAA,YAAA;AAEF;;AACA,oCAAA;AACA;EACE,aAAA;AAEF;;AACA,0BAAA;AACA;EACE,qBAAA,EAAA,YAAA;AAEF;;AACA,6CAAA;AACA;EACE,cAAA;EACA,WAAA;AAEF;;AACA;EACE,gBAAA;EACA,kBAAA;AAEF;;AACA;EACE,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;AAEF;;AACA;EACE,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,iCAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;AAEF;;AACA;EACE,yBAAA;AAEF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;AACF","sourcesContent":[".tag-slider-wrapper {\r\n  width: 100%;\r\n  overflow-x: auto;\r\n  overflow-y: hidden;\r\n  -webkit-overflow-scrolling: touch;\r\n  scrollbar-width: none; /* Firefox */\r\n}\r\n\r\n/* Ẩn scrollbar trên Chrome/Safari */\r\n.tag-slider-wrapper::-webkit-scrollbar {\r\n  display: none;\r\n}\r\n\r\n/* Hover: hiện scrollbar */\r\n.tag-slider-wrapper:hover {\r\n  scrollbar-width: thin;        /* Firefox */\r\n}\r\n\r\n/* Hover: hiện scrollbar trên Chrome/Safari */\r\n.tag-slider-wrapper:hover::-webkit-scrollbar {\r\n  display: block;\r\n  height: 6px;\r\n}\r\n\r\n.tag-slider-wrapper:hover::-webkit-scrollbar-thumb {\r\n  background: #999;\r\n  border-radius: 3px;\r\n}\r\n\r\n.tag-slider-track {\r\n  display: flex;\r\n  flex-wrap: nowrap;\r\n  width: max-content;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.tag-item {\r\n  background-color: #f1f4ff;\r\n  border-radius: 12px;\r\n  cursor: pointer;\r\n  font-size: 16px;\r\n  color: #198754;\r\n  transition: background-color 0.2s;\r\n  margin-right: 12px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  padding: 8px 12px;\r\n  white-space: nowrap;\r\n  flex: 0 0 auto;\r\n  border: none;\r\n}\r\n\r\n.tag-item:hover {\r\n  background-color: #e0eaff;\r\n}\r\n\r\n\r\n.tag-icon {\r\n  width: 25px;\r\n  height: 25px;\r\n  margin-right: 8px;\r\n  object-fit: contain;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
